import { ApiService } from '@shared/services';
import { PaginationRequestModel, PaginationResponseModel } from '@/shared/src/models/Pagination';
import { IChildService } from '@parents/interfaces/services';
import { ChildAddModel, ChildModel, ChildUpdateModel } from '@parents/models/Child';

export class ChildService extends ApiService implements IChildService {
    constructor() {
        super('/parent/child');
    }

    getItems(params: PaginationRequestModel): Promise<PaginationResponseModel<ChildModel>> {
        const cancelToken = this.getCancelToken('getChildItemsToken');
        return this.get('/get', { cancelToken, params });
    }

    deleteItems(entries: ChildModel[]): Promise<any> {
        const deletePromises = entries.map((entry: ChildModel) =>
            this.delete(`/delete?id=${entry.id}`));
        return Promise.all(deletePromises);
    }

    addChild(params: ChildAddModel): Promise<any> {
        return this.post('/add', params);
    }

    updateChild(params: ChildUpdateModel): Promise<any> {
        return this.put('/update', params);
    }
}
